export function createRegexFromFormat(formatString: string): RegExp {
  let escapedFormat = formatString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  // Replace placeholders with appropriate regex patterns
  escapedFormat = escapedFormat
    .replace('\\{grade\\}', '(\\w+)')
    .replace('\\{unit\\}', '(\\d+)')
    .replace('\\{module\\}', '(\\d+)')
    .replace('\\{lesson\\}', '(\\d+)')
    .replace('\\{character\\}', '(\\d+)')
    .replace('\\{name\\}', '(.+)')
    .replace('\\{GRADE\\}', '(\\w+)')
    .replace('\\{UNIT\\}', '(\\d+)')
    .replace('\\{LESSON\\}', '(\\d+)')
    .replace('\\{CHARACTER\\}', '(\\d+)')
    .replace('\\{NAME\\}', '(.+)')

  // Replace any occurrence of a dash with a character class that matches -, –, —
  escapedFormat = escapedFormat.replace(/[-–—]/g, '[-–—]')

  return new RegExp('^' + escapedFormat + '$')
}
